/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel, PublicClientApplication } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID, // This is the ONLY mandatory field that you need to supply.
        authority: process.env.REACT_APP_AUTHORITY, // Choose SUSI as your default authority.
        knownAuthorities:  [...process.env.REACT_APP_KNOWN_AUTHORITY.split(',')], // Mark your B2C tenant's domain as trusted.
        // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
        redirectUri: window.location.origin,
        postLogoutRedirectUri:  process.env.REACT_APP_POSTBACK_URL,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;		
                    default:
                        return;
                }	
            }	
        },
        //need to have this if not cannot logout. Error:Refused to display 'https://login.microsoftonline.com/' in a frame because it set 'X-Frame-Options' to 'deny'?
        allowRedirectInIframe: true	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [...process.env.REACT_APP_CLIENT_SCOPE.split(',')] 
  //  scopes: ["User.Read"]
};
export const accessTokenRequestScope = {
    scopes:[...process.env.REACT_APP_ACCESSTOKEN_CLIENT_SCOPE.split(',')] 
  //  scopes: ["User.Read"]
};
export const msalInstance = new PublicClientApplication(msalConfig);